module.exports = __webpack_public_path__ + "static/flags/EG-dc699039f5822d5add3e0d8621c0df6e.gif";